import MainURL from '../../Admin/MainURL';
import mmLogo from '../../images/ministermore/logo.png';
import mmWebMain from '../../images/ministermore/web/01_main.jpg';
import mmFullRecruit from '../../images/ministermore/full/02_recruit.jpg';
import mmFullRecruitDetail from '../../images/ministermore/full/20_recruit_detail.jpg';
import mmFullMinister from '../../images/ministermore/full/06_minister.jpg';
import mmFullAi from '../../images/ministermore/full/11_aiservice.jpg';
import mmFullRetreat from '../../images/ministermore/full/07_retreat.jpg';
import mmFullRetreatCasting from '../../images/ministermore/full/09_retreat_casting.jpg';
import mmAppHome from '../../images/ministermore/app/01_home.jpg';
import mmAppJobs from '../../images/ministermore/app/03_jobs.jpg';
import mmAppJobDetail from '../../images/ministermore/app/04_job_detail.jpg';
import mmAppMinisters from '../../images/ministermore/app/07_ministers.jpg';
import mmAppMinisterDetail from '../../images/ministermore/app/08_minister_detail.jpg';
import mmAppAi from '../../images/ministermore/app/10_ai.jpg';
import mmAppAiConti from '../../images/ministermore/app/12_ai_conti.jpg';
import mmAppRetreat from '../../images/ministermore/app/13_retreat.jpg';
import mmAppRetreatPlace from '../../images/ministermore/app/14_retreat_place_detail.jpg';
import mmAppBoard from '../../images/ministermore/app/18_board.jpg';
import caLogo from '../../images/churchappmore/logo.png';
import caWebMain from '../../images/churchappmore/web/01-main.jpg';
import caFullMember from '../../images/churchappmore/full/02-service-member.jpg';
import caFullAdmin from '../../images/churchappmore/full/03-service-admin.jpg';
import caFullRoll from '../../images/churchappmore/full/04-service-roll.jpg';
import caFullFinance from '../../images/churchappmore/full/05-service-finance.jpg';
import caFullSundaySchool from '../../images/churchappmore/full/06-service-sundayschool.jpg';
import caFullPrice from '../../images/churchappmore/full/08-price.jpg';
import caAppWorship from '../../images/churchappmore/app/member-worship.jpg';
import caAppNews from '../../images/churchappmore/app/member-news.jpg';
import caAppBible from '../../images/churchappmore/app/member-bible.jpg';
import caAppSermon from '../../images/churchappmore/app/member-sermon.jpg';
import caAppAdminNews from '../../images/churchappmore/app/admin-news-form.jpg';
import caAppRollMembers from '../../images/churchappmore/app/roll-members.jpg';
import caAppRollAttendance from '../../images/churchappmore/app/roll-attendance.jpg';
import caAppFinance from '../../images/churchappmore/app/finance-list.jpg';
import caAppSchoolTeacher from '../../images/churchappmore/app/sundayschool-teacher.jpg';
import caAppSchoolParent from '../../images/churchappmore/app/sundayschool-parent.jpg';
import cfWebMain from '../../images/cafeappmore/web/01_main.jpg';
import cfFullHome from '../../images/cafeappmore/full/01_home.jpg';
import cfFullMenuModal from '../../images/cafeappmore/full/02_menu_modal.jpg';
import cfFullOwnerOrders from '../../images/cafeappmore/full/04_owner_orders.jpg';
import cfFullOwnerMenu from '../../images/cafeappmore/full/05_owner_menu.jpg';
import cfFullOwnerOperation from '../../images/cafeappmore/full/06_owner_operation.jpg';
import cfFullOwnerSales from '../../images/cafeappmore/full/07_owner_sales.jpg';
import cfFullOwnerSalesMonthly from '../../images/cafeappmore/full/08_owner_sales_monthly.jpg';
import cfFullAdminStores from '../../images/cafeappmore/full/11_admin_stores.jpg';
import cfFullAdminApproval from '../../images/cafeappmore/full/12_admin_approval.jpg';
import cfAppHome from '../../images/cafeappmore/app/customer_home.jpg';
import cfAppMenu from '../../images/cafeappmore/app/customer_menu.jpg';
import cfAppMenuDetail from '../../images/cafeappmore/app/customer_menu_detail.jpg';
import cfAppCart from '../../images/cafeappmore/app/customer_cart.jpg';
import cfAppCheckout from '../../images/cafeappmore/app/customer_checkout.jpg';
import cfAppOrders from '../../images/cafeappmore/app/customer_orders.jpg';
import cfAppBenefits from '../../images/cafeappmore/app/customer_benefits.jpg';
import cfAppOwnerOrders from '../../images/cafeappmore/app/owner_orders.jpg';
import cfAppOwnerPickup from '../../images/cafeappmore/app/owner_pickup.jpg';
import cfAppOwnerSoldout from '../../images/cafeappmore/app/owner_soldout.jpg';
import cfAppOwnerBranding from '../../images/cafeappmore/app/owner_branding.jpg';
import cfAppOwnerAlert from '../../images/cafeappmore/app/owner_new_order_alert.jpg';
import jfLogo from '../../images/jobfairmore/logo.png';
import jfWebDashboard from '../../images/jobfairmore/web/05_dashboard.jpg';
import jfFullBoothStats from '../../images/jobfairmore/full/06_booth_stats.jpg';
import jfFullAppUxStats from '../../images/jobfairmore/full/10_app_ux_stats.jpg';
import jfFullReviews from '../../images/jobfairmore/full/07_reviews.jpg';
import jfFullFloorplan from '../../images/jobfairmore/full/15_floorplan.jpg';
import jfFullCompanies from '../../images/jobfairmore/full/17_companies.jpg';
import jfFullBoothStatus from '../../images/jobfairmore/full/19_booth_status.jpg';
import jfFullStudents from '../../images/jobfairmore/full/22_students.jpg';
import jfFullPushNotice from '../../images/jobfairmore/full/08_push_notice.jpg';
import jfAppPoster from '../../images/jobfairmore/app/02_intro_poster.jpg';
import jfAppRoleSelect from '../../images/jobfairmore/app/03_intro_role_select.jpg';
import jfAppBooths from '../../images/jobfairmore/app/10_student_booths_home.jpg';
import jfAppCompanies from '../../images/jobfairmore/app/11_student_company_list.jpg';
import jfAppCompanyDetail from '../../images/jobfairmore/app/18_student_company_detail.jpg';
import jfAppSideEvents from '../../images/jobfairmore/app/13_student_side_events.jpg';
import jfAppBoothMap from '../../images/jobfairmore/app/14_student_booth_map.jpg';
import jfAppMyReservations from '../../images/jobfairmore/app/17_student_my_reservations.jpg';
import jfAppReviewForm from '../../images/jobfairmore/app/22_student_review_form.jpg';
import jfAppCompanyConsole from '../../images/jobfairmore/app/23_company_reservations.jpg';
import jfAppProfessionalConsole from '../../images/jobfairmore/app/28_professional_reservations.jpg';
import gwLogo from '../../images/gworks/logo.png';
import gwWebHome from '../../images/gworks/web/01_home.jpg';
import gwFullHome from '../../images/gworks/full/01_home.jpg';
import gwFullGreeting from '../../images/gworks/full/02_company_greeting.jpg';
import gwFullVision from '../../images/gworks/full/03_company_vision.jpg';
import gwFullLocation from '../../images/gworks/full/04_company_location.jpg';
import gwFullPortfolio from '../../images/gworks/full/05_portfolio.jpg';
import gwFullQuote from '../../images/gworks/full/07_quote.jpg';
import gwFullWowpress from '../../images/gworks/full/09_wowpress.jpg';
import gwFullFaq from '../../images/gworks/full/10_faq.jpg';
import gwFullLookup from '../../images/gworks/full/11_lookup.jpg';
import gwFullLogin from '../../images/gworks/full/12_login.jpg';
import saLogo from '../../images/1001again/logo.png';
import saWebMain from '../../images/1001again/web/01_main.jpg';
import saFullMain from '../../images/1001again/full/01_main.jpg';
import saFullGreeting from '../../images/1001again/full/02_greeting.jpg';
import saFullVision from '../../images/1001again/full/03_vision.jpg';
import saFullServices from '../../images/1001again/full/04_services.jpg';
import saFullAbout from '../../images/1001again/full/05_about.jpg';
import saFullLocation from '../../images/1001again/full/06_location.jpg';
import saFullPrograms from '../../images/1001again/full/07_programs.jpg';
import saFullDonations from '../../images/1001again/full/08_donations.jpg';
import saFullSupport from '../../images/1001again/full/09_support.jpg';
import saFullPracticum from '../../images/1001again/full/11_practicum.jpg';
import saFullSelfSupport from '../../images/1001again/full/12_selfsupport.jpg';
import saFullNotices from '../../images/1001again/full/13_notices.jpg';
// 드럼하이 — 잠시 숨김
// import dhLogo from '../../images/drumhi/logo.jpg';
// import dhWebIntro from '../../images/drumhi/web/01_intro.jpg';
// import dhFullLibrary from '../../images/drumhi/full/02b_library_song_selected.jpg';
// import dhFullPreparation from '../../images/drumhi/full/06_preparation.jpg';
// import dhFullGameplay from '../../images/drumhi/full/07_gameplay.jpg';
// import dhFullResults from '../../images/drumhi/full/08_results.jpg';
// import dhFullCognitive from '../../images/drumhi/full/03_cognitive.jpg';
// import dhFullCognitiveGame from '../../images/drumhi/full/09_cognitive_game.jpg';
// import dhFullSubscription from '../../images/drumhi/full/05_subscription.jpg';
// import dhFullNotifications from '../../images/drumhi/full/12_notifications.jpg';
// import dhFullHelp from '../../images/drumhi/full/14_help.jpg';
// import dhFullSettings from '../../images/drumhi/full/15_user_settings.jpg';
// import dhFullAdminDashboard from '../../images/drumhi/full/22_admin_dashboard.jpg';
// import dhFullAdminScoreRegister from '../../images/drumhi/full/26_admin_score_register.jpg';
import crLogo from '../../images/churchrecords/logo.png';
import crWebMain from '../../images/churchrecords/web/01_main.jpg';
import crFullMain from '../../images/churchrecords/full/01_main.jpg';
import crFullIntro from '../../images/churchrecords/full/02_intro.jpg';
import crFullArchiving from '../../images/churchrecords/full/03_archiving.jpg';
import crFullApply from '../../images/churchrecords/full/04_apply.jpg';
import crFullHome from '../../images/churchrecords/full/10_home.jpg';
import crFullMeeting from '../../images/churchrecords/full/13_meeting.jpg';
import crFullSchedule from '../../images/churchrecords/full/11_schedule.jpg';
import crFullCommunity from '../../images/churchrecords/full/12_community.jpg';
import crFullAdminDashboard from '../../images/churchrecords/full/41_admin_dashboard.jpg';
import crAppStart from '../../images/churchrecords/app/02_start.jpg';
import crAppHome from '../../images/churchrecords/app/10_home.jpg';
import crAppMeeting from '../../images/churchrecords/app/11_meeting.jpg';
import crAppSchedule from '../../images/churchrecords/app/12_schedule.jpg';
import crAppCommunity from '../../images/churchrecords/app/13_community.jpg';
import crAppMypage from '../../images/churchrecords/app/27_mypage.jpg';

export type ProjectCategory = 'own' | 'outsource';

export interface ProjectScreen {
  imageUrl: string;
  caption: string;
  // 지정하면 상세 페이지에서 웹(첫 장은 Main Page, 나머지는 Sub Page) / 모바일 화면으로 나눠 보여준다
  kind?: 'web' | 'mobile';
}

export interface ApiProject {
  id: number;
  title: string;
  description: string;
  category: string;
  tech_stacks: string | string[];
  image_url: string;
  project_url?: string;
  web_url?: string;
  android_url?: string;
  ios_url?: string;
  headline?: string;
  client_name?: string;
  industry?: string;
  period?: string;
  scope?: string;
  platform?: string;
  challenge?: string;
  approach?: string;
  result?: string;
  screens?: { image_url: string; caption?: string }[];
  next?: { id: number; title: string } | null;
}

export interface Project {
  id: number;
  title: string;
  description: string;
  category: ProjectCategory;
  thumbnailUrl: string;
  techStack: string[];
  projectUrl: string;
  webUrl: string;
  androidUrl: string;
  iosUrl: string;
  headline: string;
  client: string;
  industry: string;
  period: string;
  scope: string;
  platform: string;
  challenge: string;
  approach: string;
  result: string;
  screens: ProjectScreen[];
  // 상세 페이지 Content 띠 등에 쓰는 프로젝트 대표 색 (없으면 기본 accent)
  themeColor?: string;
  // 지정하면 포트폴리오 목록 카드에 thumbnailUrl 대신 로고를 잘리지 않게 보여준다
  logoUrl?: string;
}

export const PROJECTS_API_URL = `${MainURL}/api/projects`;

export const CATEGORY_LABELS: Record<ProjectCategory, string> = {
  own: '자체 플랫폼',
  outsource: '외주 프로젝트',
};

const parseTechStacks = (value: string | string[]): string[] => {
  if (Array.isArray(value)) {
    return value.map((item) => item.trim()).filter(Boolean);
  }

  return (value || '').split(',').map((item) => item.trim()).filter(Boolean);
};

// 'own'이 아니면(기존 'web'/'app' 값 포함) 외주 프로젝트로 분류
const normalizeCategory = (value: string): ProjectCategory =>
  value === 'own' ? 'own' : 'outsource';

export const normalizeProject = (raw: ApiProject): Project => ({
  id: raw.id,
  title: raw.title,
  description: raw.description,
  category: normalizeCategory(raw.category),
  thumbnailUrl: raw.image_url || '',
  techStack: parseTechStacks(raw.tech_stacks),
  projectUrl: raw.project_url || '',
  // 웹 링크가 비어 있으면 기존 project_url 을 웹 링크로 사용
  webUrl: raw.web_url || raw.project_url || '',
  androidUrl: raw.android_url || '',
  iosUrl: raw.ios_url || '',
  headline: raw.headline || '',
  client: raw.client_name || '',
  industry: raw.industry || '',
  period: raw.period || '',
  scope: raw.scope || '',
  platform: raw.platform || '',
  challenge: raw.challenge || '',
  approach: raw.approach || '',
  result: raw.result || '',
  screens: (raw.screens || [])
    .filter((screen) => screen?.image_url)
    .map((screen) => ({ imageUrl: screen.image_url, caption: screen.caption || '' })),
});

const EMPTY_DETAIL = {
  thumbnailUrl: '',
  challenge: '',
  period: '',
  result: '',
  screens: [],
};

const webScreen = (imageUrl: string, caption: string): ProjectScreen => ({ imageUrl, caption, kind: 'web' });
const appScreen = (imageUrl: string, caption: string): ProjectScreen => ({
  imageUrl,
  caption,
  kind: 'mobile',
});

export const FEATURED_PROJECTS: Project[] = [
  {
    ...EMPTY_DETAIL,
    id: -1000,
    thumbnailUrl: mmWebMain,
    screens: [
      webScreen(mmWebMain, '메인'),
      webScreen(mmFullRecruit, '구인정보'),
      webScreen(mmFullRecruitDetail, '채용공고 상세'),
      webScreen(mmFullMinister, '사역자정보'),
      webScreen(mmFullAi, 'AI 사역지원'),
      webScreen(mmFullRetreat, '수련회 장소'),
      webScreen(mmFullRetreatCasting, '수련회 강사 섭외'),
      appScreen(mmAppHome, '홈'),
      appScreen(mmAppJobs, '구인정보'),
      appScreen(mmAppMinisters, '사역자정보'),
      appScreen(mmAppAi, 'AI 사역지원'),
      appScreen(mmAppJobDetail, '채용공고 상세'),
      appScreen(mmAppMinisterDetail, '사역자 상세'),
      appScreen(mmAppAiConti, '예배 콘티'),
      appScreen(mmAppRetreat, '수련회'),
      appScreen(mmAppRetreatPlace, '수련회 장소 상세'),
      appScreen(mmAppBoard, '게시판'),
    ],
    title: '사역자모아',
    description:
      '교회와 사역자를 연결하는 구인구직·사역 지원 플랫폼. 채용공고, 수련회 장소·강사, AI 설교지원·콘티·찬양 찾기, 커뮤니티까지 한곳에서 제공합니다.',
    category: 'own',
    techStack: ['React', 'React Native', 'Node.js', 'MySQL', 'AWS'],
    projectUrl: 'https://ministermore.co.kr/',
    webUrl: 'https://ministermore.co.kr/',
    androidUrl: 'https://play.google.com/store/apps/details?id=com.ministermore',
    iosUrl: 'https://apps.apple.com/kr/app/%EC%82%AC%EC%97%AD%EC%9E%90%EB%AA%A8%EC%95%84/id6771267063',
    headline: '교회와 사역자를 잇는 사역 지원 플랫폼',
    client: '예플랫 (자체 서비스)',
    industry: '교회 · 사역 지원',
    scope: '기획 · UX/UI · 웹/앱 개발 · 운영',
    platform: 'Web · iOS · Android',
    themeColor: '#1e40af',
    logoUrl: mmLogo,
    approach:
      '전국 교회의 청빙 공고와 사역자 이력서를 한 곳에 모으고, 부서·지역·직분으로 찾아 바로 지원할 수 있게 구성했습니다. 여기에 수련회 장소·강사 섭외, AI 설교지원·예배 콘티·찬양 찾기, 커뮤니티 게시판까지 사역에 필요한 기능을 한 플랫폼에 담았습니다.',
    result:
      '웹과 iOS·Android 앱을 함께 운영하며, 같은 기능을 PC와 모바일 어디서나 이어서 사용할 수 있습니다.',
  },
  {
    ...EMPTY_DETAIL,
    id: -1001,
    thumbnailUrl: caWebMain,
    screens: [
      webScreen(caWebMain, '메인'),
      webScreen(caFullMember, '서비스 소개 · 성도용 앱'),
      webScreen(caFullAdmin, '서비스 소개 · 관리자 앱'),
      webScreen(caFullRoll, '서비스 소개 · 교적부'),
      webScreen(caFullFinance, '서비스 소개 · 재정'),
      webScreen(caFullSundaySchool, '서비스 소개 · 주일학교'),
      webScreen(caFullPrice, '요금 안내'),
      appScreen(caAppWorship, '성도용 · 예배순서'),
      appScreen(caAppNews, '성도용 · 교회소식'),
      appScreen(caAppBible, '성도용 · 성경읽기'),
      appScreen(caAppSermon, '성도용 · 설교영상'),
      appScreen(caAppAdminNews, '관리자 · 소식 등록'),
      appScreen(caAppRollMembers, '교적부 · 교인 목록'),
      appScreen(caAppRollAttendance, '교적부 · 출석부'),
      appScreen(caAppFinance, '재정 · 수입/지출'),
      appScreen(caAppSchoolTeacher, '주일학교 · 교사 대시보드'),
      appScreen(caAppSchoolParent, '주일학교 · 학부모 홈'),
    ],
    title: '교회앱모아',
    description:
      '우리 교회 이름으로 된 전용 앱을 만들어 드리는 서비스. 성도용 앱과 교적·재정·주일학교 앱, PC 관리자 페이지까지 한 번에 제공합니다.',
    category: 'own',
    techStack: ['React', 'React Native'],
    projectUrl: 'https://churchappmore.com/',
    webUrl: 'https://churchappmore.com/',
    androidUrl: '',
    iosUrl: '',
    headline: '우리 교회 전용 앱 제작 플랫폼',
    client: '예플랫 (자체 서비스)',
    industry: '교회 · 교회 행정',
    scope: '기획 · UX/UI · 웹/앱 개발 · 운영',
    platform: 'Web · iOS · Android',
    themeColor: '#0f3270',
    logoUrl: caLogo,
    approach:
      '성도용 앱(예배순서·교회소식·성경읽기·설교영상), 관리자 앱, 교적부, 재정, 주일학교 앱을 하나의 플랫폼으로 묶었습니다. 교회는 PC 콘솔과 관리자 앱에서 내용을 올리고, 성도·교사·학부모는 각자 필요한 앱으로 바로 확인합니다.',
    result:
      '각 교회의 이름과 로고로 iOS·Android 앱을 출시하고, 출시 후에도 업데이트를 이어서 제공합니다.',
  },
  {
    ...EMPTY_DETAIL,
    id: -1002,
    thumbnailUrl: cfWebMain,
    screens: [
      webScreen(cfWebMain, '메인'),
      webScreen(cfFullHome, '매장 홈페이지'),
      webScreen(cfFullMenuModal, '메뉴 상세'),
      webScreen(cfFullOwnerOrders, '점주 · 실시간 주문관리'),
      webScreen(cfFullOwnerMenu, '점주 · 메뉴관리'),
      webScreen(cfFullOwnerOperation, '점주 · 운영관리'),
      webScreen(cfFullOwnerSales, '점주 · 매출통계'),
      webScreen(cfFullOwnerSalesMonthly, '점주 · 월별 매출'),
      webScreen(cfFullAdminStores, '전체관리자 · 매장관리'),
      webScreen(cfFullAdminApproval, '전체관리자 · 관리자 승인'),
      appScreen(cfAppHome, '고객용 · 홈'),
      appScreen(cfAppMenu, '고객용 · 메뉴'),
      appScreen(cfAppMenuDetail, '고객용 · 메뉴 상세'),
      appScreen(cfAppCart, '고객용 · 장바구니'),
      appScreen(cfAppCheckout, '고객용 · 주문결제'),
      appScreen(cfAppOrders, '고객용 · 주문내역'),
      appScreen(cfAppBenefits, '고객용 · 스탬프/쿠폰'),
      appScreen(cfAppOwnerOrders, '점주용 · 주문접수'),
      appScreen(cfAppOwnerAlert, '점주용 · 신규주문 알림'),
      appScreen(cfAppOwnerPickup, '점주용 · 제조/픽업'),
      appScreen(cfAppOwnerSoldout, '점주용 · 품절관리'),
      appScreen(cfAppOwnerBranding, '점주용 · 브랜딩'),
    ],
    title: '카페앱모아',
    description:
      '우리 카페 이름으로 된 스마트오더 앱을 만들어 드리는 서비스. 고객용 주문 앱과 점주용 관리자 앱, 매장 홈페이지와 PC 관리자 페이지까지 한 번에 제공합니다.',
    category: 'own',
    techStack: ['React', 'React Native', 'Node.js', 'MySQL'],
    projectUrl: '',
    webUrl: '',
    androidUrl: '',
    iosUrl: '',
    headline: '우리 카페 전용 스마트오더 앱 제작 플랫폼',
    client: '예플랫 (자체 서비스)',
    industry: '카페 · 외식 주문',
    scope: '기획 · UX/UI · 웹/앱 개발 · 운영',
    platform: 'Web · iOS · Android',
    themeColor: '#0e6b3f',
    approach:
      '고객은 카페 전용 앱에서 메뉴를 고르고 미리 주문·결제한 뒤 기다리지 않고 픽업하며, 스탬프와 쿠폰이 자동으로 쌓입니다. 점주는 관리자 앱과 PC 페이지에서 실시간 주문 접수, 제조·픽업 처리, 품절·메뉴·운영시간 관리, 매출 통계까지 한곳에서 다룹니다.',
    result:
      '각 카페의 이름과 로고, 브랜드 컬러로 iOS·Android 앱을 출시하고, 신규 주문 알림으로 매장 운영 흐름을 끊김 없이 이어갑니다.',
  },
  {
    ...EMPTY_DETAIL,
    id: -1003,
    thumbnailUrl: crWebMain,
    screens: [
      webScreen(crWebMain, '메인'),
      webScreen(crFullMain, '서비스 소개'),
      webScreen(crFullIntro, '교회록 소개'),
      webScreen(crFullArchiving, '문서 디지털화(OCR) 소개'),
      webScreen(crFullApply, '서비스 신청'),
      webScreen(crFullHome, '홈'),
      webScreen(crFullMeeting, '교회록 작성'),
      webScreen(crFullSchedule, '스케줄'),
      webScreen(crFullCommunity, '커뮤니티'),
      webScreen(crFullAdminDashboard, '관리자 · 대시보드'),
      appScreen(crAppStart, '시작'),
      appScreen(crAppHome, '홈'),
      appScreen(crAppMeeting, '교회록 작성'),
      appScreen(crAppSchedule, '스케줄'),
      appScreen(crAppCommunity, '커뮤니티'),
      appScreen(crAppMypage, '마이페이지'),
    ],
    title: '교회록',
    description:
      '당회·제직회 등 교회 회의록을 표준화된 디지털 양식으로 작성·보관하고, 과거 수기 회의록은 OCR로 디지털 텍스트로 변환해 주는 교회 행정 서비스입니다.',
    category: 'own',
    techStack: ['React', 'React Native', 'Node.js', 'MySQL'],
    projectUrl: '',
    webUrl: '',
    androidUrl: '',
    iosUrl: '',
    headline: '교회 회의록 디지털 작성 · 문서 디지털화 플랫폼',
    client: '예플랫 (자체 서비스)',
    industry: '교회 · 교회 행정',
    scope: '기획 · UX/UI · 웹/앱 개발 · 운영',
    platform: 'Web · iOS · Android',
    themeColor: '#0a4a32',
    logoUrl: crLogo,
    approach:
      '당회·제직회·공동의회 등 회의 종류별 표준 양식으로 기본 정보, 참석 회원, 안건과 결의 사항을 단계별로 기록하게 했습니다. 오래된 수기 회의록은 사진을 찍어 OCR로 디지털 텍스트로 바꿔 보관하고, 회의 일정 관리와 안건 의견 수렴 커뮤니티까지 함께 제공합니다.',
    result:
      '웹과 모바일 앱에서 같은 회의록을 이어서 작성·열람할 수 있고, 교회 문서를 암호화해 안전하게 영구 보관합니다.',
  },
  {
    ...EMPTY_DETAIL,
    id: -1004,
    thumbnailUrl: jfWebDashboard,
    screens: [
      webScreen(jfWebDashboard, '관리자 · 대시보드'),
      webScreen(jfFullBoothStats, '관리자 · 부스 통계'),
      webScreen(jfFullAppUxStats, '관리자 · 앱 UX 통계'),
      webScreen(jfFullReviews, '관리자 · 리뷰 설문'),
      webScreen(jfFullFloorplan, '관리자 · 배치도'),
      webScreen(jfFullCompanies, '관리자 · 참가기업 관리'),
      webScreen(jfFullBoothStatus, '관리자 · 부스 신청현황'),
      webScreen(jfFullStudents, '관리자 · 참가 학생 관리'),
      webScreen(jfFullPushNotice, '관리자 · 전체 푸시 알림'),
      appScreen(jfAppPoster, '행사 포스터'),
      appScreen(jfAppRoleSelect, '역할 선택'),
      appScreen(jfAppBooths, '학생 · 부스 홈'),
      appScreen(jfAppCompanies, '학생 · 참가 기업'),
      appScreen(jfAppCompanyDetail, '학생 · 기업 상세/대기 신청'),
      appScreen(jfAppSideEvents, '학생 · 부대행사'),
      appScreen(jfAppBoothMap, '학생 · 부스 지도'),
      appScreen(jfAppMyReservations, '학생 · 신청 현황'),
      appScreen(jfAppReviewForm, '학생 · 리뷰 설문'),
      appScreen(jfAppCompanyConsole, '기업 부스 · 참여 관리'),
      appScreen(jfAppProfessionalConsole, '현직자 · 면담 신청 관리'),
    ],
    title: '금오공대잡페어',
    description:
      '국립금오공과대학교 취업박람회를 위한 모바일 테이블링 앱. 학생은 기업·현직자·부대행사 부스에 줄 서지 않고 앱으로 대기 신청하고, 부스와 운영진은 호출·참석·노쇼와 통계를 실시간으로 관리합니다.',
    category: 'outsource',
    techStack: ['React', 'React Native', 'Node.js', 'MySQL'],
    projectUrl: '',
    webUrl: '',
    androidUrl: '',
    iosUrl: '',
    headline: '줄 서지 않는 취업박람회, 부스 대기 신청 앱',
    client: '국립금오공과대학교',
    industry: '대학 · 취업박람회',
    scope: '기획 · UX/UI · 웹/앱 개발 · 운영',
    platform: 'Web(관리자) · iOS · Android',
    themeColor: '#f36316',
    logoUrl: jfLogo,
    approach:
      '학생은 앱에서 참가 기업, 현직자 면담, 부대행사 부스를 날짜별로 찾아보고 부스 지도로 위치를 확인한 뒤 바로 대기 신청합니다. 각 부스는 전용 콘솔에서 대기 학생을 호출하고 참석·노쇼를 처리하며, 운영진은 웹 관리자에서 참가 기업·학생·배치도·푸시 알림을 관리합니다.',
    result:
      '종이 대기표와 무작정 줄 서기를 앱 대기 신청으로 바꾸고, 부스별 예약·참석 현황과 앱 이용 통계, 행사 후 리뷰 설문까지 한곳에서 확인할 수 있게 했습니다.',
  },
  {
    ...EMPTY_DETAIL,
    id: -1006,
    thumbnailUrl: gwWebHome,
    screens: [
      webScreen(gwWebHome, '메인'),
      webScreen(gwFullHome, '홈'),
      webScreen(gwFullGreeting, '회사소개 · 인사말'),
      webScreen(gwFullVision, '회사소개 · 비전과 회사플랫폼'),
      webScreen(gwFullLocation, '회사소개 · 오시는 길'),
      webScreen(gwFullPortfolio, '포트폴리오'),
      webScreen(gwFullQuote, '견적문의'),
      webScreen(gwFullWowpress, '와우프레스 실시간 견적'),
      webScreen(gwFullFaq, '자주 묻는 질문'),
      webScreen(gwFullLookup, '주문조회'),
      webScreen(gwFullLogin, '로그인 · 카카오/네이버'),
    ],
    title: '지웍스',
    description:
      '인쇄부터 후가공까지 원스톱으로 제작하는 디자인앤컴퍼니 지웍스(G-WORKS)의 홈페이지. 디자인 포트폴리오와 견적·주문·결제, 주문조회를 한 곳에서 제공합니다.',
    category: 'outsource',
    techStack: ['React', 'Node.js', 'MySQL'],
    projectUrl: '',
    webUrl: '',
    androidUrl: '',
    iosUrl: '',
    headline: '디자인 포트폴리오와 견적·주문·결제를 한 곳에서',
    client: '디자인앤컴퍼니 지웍스',
    industry: '인쇄 · 패키지 디자인',
    scope: '기획 · UX/UI · 웹 개발',
    platform: 'Web (PC · Mobile)',
    themeColor: '#4b2a7b',
    logoUrl: gwLogo,
    approach:
      '쇼핑백·박스·카드 패키지 등 제작 사례를 포트폴리오로 보여주고, 고객이 비회원 또는 회원으로 견적문의를 남기면 바로 주문과 결제로 이어지도록 구성했습니다. 와우프레스 제품의 실시간 견적 미리보기, 주문번호로 하는 진행 상황 조회, 카카오·네이버 간편 로그인을 함께 제공합니다.',
    result:
      'PC와 모바일 어디서나 포트폴리오 확인부터 견적, 결제, 주문조회까지 한 사이트에서 이어지도록 만들었습니다.',
  },
  {
    ...EMPTY_DETAIL,
    id: -1007,
    thumbnailUrl: saWebMain,
    screens: [
      webScreen(saWebMain, '메인'),
      webScreen(saFullMain, '홈'),
      webScreen(saFullGreeting, '시설소개 · 인사말'),
      webScreen(saFullVision, '시설소개 · 비전과 미션'),
      webScreen(saFullServices, '시설소개 · 제공 서비스'),
      webScreen(saFullAbout, '시설소개 · 기관 소개'),
      webScreen(saFullLocation, '시설소개 · 오시는 길'),
      webScreen(saFullPrograms, '갤러리 · 프로그램'),
      webScreen(saFullDonations, '갤러리 · 후원물품'),
      webScreen(saFullSupport, '후원 안내'),
      webScreen(saFullPracticum, '실습 안내'),
      webScreen(saFullSelfSupport, '자활사업단'),
      webScreen(saFullNotices, '게시판 · 공지사항'),
    ],
    title: '새삶공동체',
    description:
      '노숙인자활시설 새삶공동체의 홈페이지. 시설과 제공 서비스 소개, 프로그램·후원물품 갤러리, 후원·자원봉사·실습 안내, 공지사항과 문의 게시판을 제공합니다.',
    category: 'outsource',
    techStack: ['React', 'Node.js', 'MySQL'],
    projectUrl: '',
    webUrl: '',
    androidUrl: '',
    iosUrl: '',
    headline: '자립과 회복을 응원하는 노숙인자활시설 홈페이지',
    client: '노숙인자활시설 새삶공동체',
    industry: '사회복지 · 자활 지원',
    scope: '기획 · UX/UI · 웹 개발',
    platform: 'Web (PC · Mobile)',
    themeColor: '#4f8a2e',
    logoUrl: saLogo,
    approach:
      '시설의 비전과 주거·생계·의료·심리·직업 재활 서비스를 알기 쉽게 정리하고, 프로그램 활동과 후원물품을 사진 갤러리로 꾸준히 올릴 수 있게 했습니다. 후원·자원봉사·실습 신청 안내와 자활사업단 소개, 공지사항과 익명 문의/고충처리 게시판을 함께 구성했습니다.',
    result:
      '관리자 페이지에서 공지사항과 갤러리를 직접 올리고 관리하며, PC와 모바일 어디서나 시설 소식을 확인할 수 있습니다.',
  },
  // 드럼하이 — 잠시 숨김
  // {
  //   ...EMPTY_DETAIL,
  //   id: -1005,
  //   thumbnailUrl: dhWebIntro,
  //   screens: [
  //     webScreen(dhWebIntro, '시작 화면'),
  //     webScreen(dhFullLibrary, '드럼 · 곡 선택'),
  //     webScreen(dhFullPreparation, '드럼 · 난이도 선택'),
  //     webScreen(dhFullGameplay, '드럼 · 연주 플레이'),
  //     webScreen(dhFullResults, '드럼 · 연주 결과 분석'),
  //     webScreen(dhFullCognitive, '인지 · 활동 목록'),
  //     webScreen(dhFullCognitiveGame, '인지 · 학습 기준 선택'),
  //     webScreen(dhFullSubscription, '드럼하이 패스 구독'),
  //     webScreen(dhFullNotifications, '알림 설정'),
  //     webScreen(dhFullHelp, '도움말'),
  //     webScreen(dhFullSettings, '앱 설정'),
  //     webScreen(dhFullAdminDashboard, '관리자 · 대시보드'),
  //     webScreen(dhFullAdminScoreRegister, '관리자 · 악보 등록'),
  //   ],
  //   title: '드럼하이',
  //   description:
  //     'MIDI 드럼으로 곡을 연주하며 리듬감을 키우고, 색상·순서 기억 등 인지 활동까지 함께 하는 리듬 학습 앱. 구독 결제와 악보·인지 콘텐츠를 관리하는 관리자 페이지를 함께 제공합니다.',
  //   category: 'outsource',
  //   techStack: ['React', 'React Native', 'Node.js', 'MySQL'],
  //   projectUrl: '',
  //   webUrl: '',
  //   androidUrl: '',
  //   iosUrl: '',
  //   headline: '드럼 연주와 인지 훈련을 함께하는 리듬 학습 앱',
  //   client: '주은에듀테크',
  //   industry: '교육 · 음악 · 인지 훈련',
  //   scope: '기획 · UX/UI · 앱/관리자 개발',
  //   platform: 'Tablet App · Web(관리자)',
  //   themeColor: '#1d4ed8',
  //   logoUrl: dhLogo,
  //   approach:
  //     '곡을 고르고 Easy·Normal·Hard 중 난이도를 선택하면 화면의 노트에 맞춰 MIDI 드럼을 연주하고, 끝나면 정확도와 타이밍, 자주 틀린 악기까지 분석해 보여줍니다. 유아부터 고령층까지 연령별 기준을 고를 수 있는 인지 활동과 드럼·인지·플러스 구독 상품을 함께 구성했습니다.',
  //   result:
  //     '관리자 페이지에서 ABC 악보 코드로 난이도별 악보를 등록하고, 회원·구독·악보/인지 플레이 로그와 인기 콘텐츠를 대시보드에서 확인할 수 있게 했습니다.',
  // },
];

export interface PlatformLink {
  key: 'web' | 'android' | 'ios';
  label: string;
  url: string;
}

// 입력된 링크만 웹 → 안드로이드 → 애플 순서로 반환
export const getPlatformLinks = (project: Project): PlatformLink[] =>
  [
    { key: 'web' as const, label: '웹', url: project.webUrl },
    { key: 'android' as const, label: '안드로이드 앱', url: project.androidUrl },
    { key: 'ios' as const, label: '애플 앱', url: project.iosUrl },
  ].filter((link) => link.url);

export const mergeFeaturedProjects = (projects: Project[]): Project[] => {
  const existingTitles = new Set(projects.map((project) => project.title.trim().toLowerCase()));
  const missing = FEATURED_PROJECTS.filter(
    (project) => !existingTitles.has(project.title.trim().toLowerCase())
  );
  return [...missing, ...projects];
};
